export default __webpack_public_path__ + "static/media/smiley_2.ba13b783.svg";